$(document).ready(function () {

  // var totalItems = $('.sub-collections .sub-collections-item').length;

  // if (totalItems > 1) { 

  //     $('.sub-collections').slick({
  //         slidesToShow: 4,
  //         slidesToScroll: 1,
  //         arrows: true,
  //         dots: false,
  //         infinite: false,
  //         adaptiveHeight: true,
  //         responsive: [
  //             {
  //                 breakpoint: 1200,
  //                 settings: {
  //                     slidesToShow: 3
  //                 }
  //             },
  //             {
  //                 breakpoint: 990, 
  //                 settings: {
  //                     slidesToShow: 2
  //                 }
  //             },
  //             {
  //                 breakpoint: 551, 
  //                 settings: {
  //                     slidesToShow: 1
  //                 }
  //             }
  //         ]
  //     });

  // }

$('.banner-list').slick({
  arrows: true,
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  adaptiveHeight: true,
   autoplay: true,
  autoplaySpeed: 5000, 
  pauseOnHover: false,
  pauseOnFocus: false,
  customPaging: function(slider, i) {
    return '<button>' + ('0' + (i + 1)).slice(-2) + '</button>';
  }
});

  $(".product-tab-slider .product-tab-list").slick({
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      responsive: [
        {
          breakpoint: 1280,
          settings: {
            slidesToScroll: 1,
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 990,
          settings: {
            slidesToScroll: 1,
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 551,
          settings: {
            slidesToScroll: 1,
            slidesToShow: 1,
          },
        }
      ]
    });  

 $('.customer-slider .customer-list').slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 990,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});   
  
});


  
  // tabbed content
// http://www.entheosweb.com/tutorials/css/tabs.asp
$(".tab-container .tab_content").hide();
// $(".tab-container .tab_content:first").show();
$('.tab-container').each(function(k,v){
  $(v).find('.tab_content:first').show();
});


/* if in tab mode */
$("ul.tabs li").click(function() {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").hide();
  var activeTab = $(this).attr("rel");
  $(parent).find("#"+activeTab).fadeIn();

  $(parent).find("ul.tabs li").removeClass("active");
  $(this).addClass("active");

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(parent).find(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");

  $('.product-tab-list').slick('refresh');
});

/* if in drawer mode */
$(".tab_drawer_heading").click(function() {
  var parent = $(this).parents('.tab-container');

  $(parent).find(".tab_content").hide();
  var d_activeTab = $(this).attr("rel");
  $(parent).find("#"+d_activeTab).fadeIn();

  $(parent).find(".tab_drawer_heading").removeClass("d_active");
  $(this).addClass("d_active");

  $(parent).find("ul.tabs li").removeClass("active");
  $(parent).find("ul.tabs li[rel^='"+d_activeTab+"']").addClass("active");

  $('.product-tab-list').slick('refresh'); 
});


// custom price range filter
document.addEventListener("change", function (e) {
  if (!e.target.matches("input[name='price_range']")) return;

  const form = e.target.closest("form");
  const min = e.target.dataset.priceMin;
  const max = e.target.dataset.priceMax;

  form.querySelectorAll(".price-range-item").forEach((item) => {
    item.classList.remove("active");
  });

  e.target.closest(".price-range-item").classList.add("active");

  form.querySelector("input[name='filter.v.price.gte']").value = min;
  form.querySelector("input[name='filter.v.price.lte']").value = max;

  form.dispatchEvent(new Event("input", { bubbles: true }));
});

// custom layout views
document.addEventListener("DOMContentLoaded", () => {

  document.addEventListener("click", function (e) {
    const clicked = e.target.closest(".layout_view .columns");

    if (!clicked) return;

    const productGrid = document.getElementById("product-grid");
    if (!productGrid) return;

    if (clicked.classList.contains("layout_type")) {

      if (clicked.classList.contains("active_grid")) {

        // Switch to List
        productGrid.classList.remove("grid");
        productGrid.classList.add("flex", "custom_layout_list");

        document
          .querySelectorAll(".layout_view .columns")
          .forEach(el => el.classList.remove("active"));

        clicked.classList.remove("active_grid");
        clicked.classList.add("active_list", "active");

      } else {

        // Switch to Grid
        productGrid.classList.remove("flex", "custom_layout_list");
        productGrid.classList.add("grid");

        updateGrid(3);

        document
          .querySelectorAll(".layout_view .columns")
          .forEach(el => el.classList.remove("active"));

        const grid3 = document.querySelector(
          '.layout_view .columns[data-columns="3"]'
        );

        if (grid3) {
          grid3.classList.add("active");
        }

        clicked.classList.remove("active_list", "active");
        clicked.classList.add("active_grid");
      }

      return;
    }

    const columns = clicked.dataset.columns;

    productGrid.classList.remove("flex", "custom_layout_list");
    productGrid.classList.add("grid");

    updateGrid(columns);

    document
      .querySelectorAll(".layout_view .columns")
      .forEach(el => el.classList.remove("active"));

    clicked.classList.add("active");

    // Reset layout button
    const layoutBtn = document.querySelector(".layout_view .layout_type");
    if (layoutBtn) {
      layoutBtn.classList.remove("active_list", "active");
      layoutBtn.classList.add("active_grid");
    }

  });

  // per page items to show
  const perPageSelect = document.querySelector('.products_per_page #per_page_items');
  if (perPageSelect) {
    const urlParams = new URLSearchParams(window.location.search);
    const currentPerPage = urlParams.get('perpage');

    if (currentPerPage) {
      perPageSelect.value = currentPerPage;
    }

    perPageSelect.addEventListener('change', function () {
      const selectedValue = this.value;
      const url = new URL(window.location.href);
      setTimeout(function() {
        url.searchParams.set('perpage', selectedValue);
      },1000)
    });
  }

  function updateGrid(columns) {
    const productListContainer = document.getElementById("product-grid");
    if (!productListContainer) return;

    productListContainer.className = productListContainer.className
      .replace(/grid--\d+-col-tablet-down/g, "")
      .replace(/grid--\d+-col-desktop/g, "")
      .replace(/\s+/g, " ")
      .trim();

    productListContainer.classList.add(
      `grid--${columns}-col-tablet-down`,
      `grid--${columns}-col-desktop`
    );
  }

  // product variant and price range on PDP
  const pdpPriceRange = document.querySelector('.pdp_price_range');
  const varOptions = document.querySelectorAll('.product_variants_container .variant_option');

  if (varOptions.length) {
    varOptions.forEach((varOption) => {
      varOption.addEventListener('change', function (e) {
        pdpPriceRange.classList.add('hidden');
      });
    });
  }

});

const megaMenus = document.querySelectorAll(
  '.header__inline-menu .mega-menu'
);

megaMenus.forEach(function (megaMenu) {
  const details = megaMenu.closest('details');

  if (!details) return;

  details.addEventListener('mouseenter', function () {
    details.setAttribute('open', '');
  });

  details.addEventListener('mouseleave', function () {
    details.removeAttribute('open');
  });
});